import { styled } from '@linaria/react';

export const Link = styled.a`
  color: inherit;
`;

/** Inline, text-like trigger so keyboard users can open the tooltip. */
export const TooltipTrigger = styled.button`
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

export const ConditionTooltipContent = styled.div`
  min-width: 15rem;
`;
